import { isValidWorkEmail } from '@/utils/functions/form'
import { object, string } from 'yup'

export type FormValues = {
  firstName: string
  lastName: string
  email: string
  company: string
}

export const initialFormValues: FormValues = {
  firstName: '',
  lastName: '',
  email: '',
  company: ''
}

export const validationSchema = object().shape({
  firstName: string().required('Please enter your first name'),
  lastName: string().required('Please enter your last name'),
  email: string()
    .email('Please enter work email address')
    .test('email', 'Please enter your work email address', value =>
      isValidWorkEmail(value ?? '')
    )
    .required('This field is required'),
  company: string().required('Please enter your company name')
})
